<template>
  <div class="timeline-filters">
    <div class="timeline-types" role="group" aria-label="Type de consultation">
      <button v-for="option in types" :key="option.value" type="button" :aria-pressed="filters.type === option.value ? 'true' : 'false'"
        :class="{ selected: filters.type === option.value }" @click="$emit('filter', 'type', option.value)">{{ option.label }}</button>
    </div>
    <div class="timeline-search-row">
      <div class="timeline-search">
        <label :for="'timeline-search-' + uid">Rechercher dans l’historique</label>
        <input :id="'timeline-search-' + uid" type="search" class="ui-search-field" :value="filters.q" maxlength="200"
          placeholder="Diagnostic, médecin ou spécialité" @input="$emit('search', $event.target.value)">
      </div>
      <div class="timeline-year">
        <label :for="'timeline-year-' + uid">Année</label>
        <select :id="'timeline-year-' + uid" :value="filters.year" @change="$emit('filter', 'year', $event.target.value)">
          <option value="ALL">Toutes les années</option>
          <option v-for="year in years" :key="year" :value="String(year)">{{ year }}</option>
        </select>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TimelineFilterBar',
  props: { filters: { type: Object, required: true }, years: { type: Array, default: () => [] }, uid: { type: [String, Number], required: true } },
  data() { return { types: [
    { value: 'ALL', label: 'Toutes' }, { value: 'GENERAL', label: 'Médecine générale' },
    { value: 'SPECIALTY', label: 'Spécialités' }, { value: 'URGENCY', label: 'Urgences & Transferts' }
  ] } }
}
</script>
<style scoped lang="scss">
.timeline-filters { margin-bottom: 22px; }
.timeline-types { display: flex; flex-wrap: wrap; gap: 8px; margin: 18px 0; }
.timeline-types button { border: 1px solid #9aaac1; border-radius: 999px; padding: 8px 16px; min-height: 42px; background: white; color: var(--ui-text-secondary, #273449); font: inherit; }
.timeline-types .selected { background: var(--ui-accent, #2457c5); color: white; border-color: var(--ui-accent, #2457c5); }
.timeline-search-row { display: flex; align-items: flex-end; flex-wrap: wrap; gap: 16px; }
.timeline-search { flex: 1 1 300px; min-width: 0; } .timeline-year { flex: 0 1 210px; }
label { display: block; color: var(--ui-text-secondary, #273449); font-weight: 600; margin-bottom: 6px; }
input, select { width: 100%; } select { height: 48px; border-radius: 14px; border: 1px solid #9aaac1; padding: 0 12px; background: white; color: var(--ui-text, #172033); font: inherit; }
button:focus-visible, select:focus-visible { outline: 2px solid var(--ui-accent, #2457c5); outline-offset: 3px; }
@media (max-width: 480px) { .timeline-search, .timeline-year { flex-basis: 100%; } }
</style>
